import { render, staticRenderFns } from "./ReplyList.vue?vue&type=template&id=9c6458a6&scoped=true"
import script from "./ReplyList.vue?vue&type=script&lang=ts"
export * from "./ReplyList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ReplyList.vue?vue&type=style&index=0&id=9c6458a6&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9c6458a6",
  "e81f3e5c"
  
)

export default component.exports